export default "__VITE_ASSET__Ax$7cg8y__"